/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { getProjectIdOrKey } from '@jira/router-resources__utils/src/getProjectKeyId.tsx';
import { createResource, type RouteResource } from '@atlassian/react-resource-router';
import type { GlobalComponentsProperties } from './GlobalComponentsProperties.types.tsx';
import { getData } from './getData.tsx';

export const RESOURCE_TYPE_PROJECT_GLOBAL_COMPONENTS = 'PROJECT_GLOBAL_COMPONENTS';

export const projectGlobalComponentsResource: RouteResource<GlobalComponentsProperties | null> =
	createResource<GlobalComponentsProperties | null>({
		type: RESOURCE_TYPE_PROJECT_GLOBAL_COMPONENTS,
		getKey: (matchedRoute) => getProjectIdOrKey(matchedRoute.match, matchedRoute.query),
		getData: (...args) => getData(...args),
	});
